import { render, staticRenderFns } from "./TemplateDetailsForm.vue?vue&type=template&id=678936c0&"
import script from "./TemplateDetailsForm.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports